var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictedAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    viewBox: "0 0 200 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155 70h-7.5V47.5C147.5 21.312 126.187 0 100 0 73.812 0 52.5 21.313 52.5 47.5V70H45c-8.281 0-15 6.719-15 15v60c0 8.281 6.719 15 15 15h110c8.281 0 15-6.719 15-15V85c0-8.281-6.719-15-15-15zm-42.5 52.5c0 6.906-5.594 12.5-12.5 12.5s-12.5-5.594-12.5-12.5v-15c0-6.906 5.594-12.5 12.5-12.5s12.5 5.594 12.5 12.5v15zm10-52.5h-45V47.5C77.5 35.094 87.594 25 100 25s22.5 10.094 22.5 22.5V70z",
    fill: "#E5E3E4",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedAccess);
export default __webpack_public_path__ + "static/media/restricted-access.c653fca3c472651b8bcb82a8ce3bff54.svg";
export { ForwardRef as ReactComponent };